import { ChangeDetectionStrategy, Component, PLATFORM_ID, effect, inject } from '@angular/core';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { Router, RouterModule } from '@angular/router';
import { MenuComponent } from './components/menu/menu.component';
import { SidebarModule } from 'primeng/sidebar';
import { MenuService } from './services/menu/menu.service';
import { AuthService } from '../services/auth/auth.service';
import { isPlatformBrowser } from '@angular/common';
import { RoutesEnum } from '../../shared/models/routes.enum';
import { DictionaryService } from '../../shared/services/dictionary/dictionary.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, MenuComponent, SidebarModule, RouterModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  // host: { ngSkipHydration: 'true' }, // todo: check if this is needed while using isPlatformBrowser
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent {
  private menuService = inject(MenuService);
  private authService = inject(AuthService);
  private platformId = inject(PLATFORM_ID);
  private router = inject(Router);
  private dictionaryService = inject(DictionaryService);

  public sidebarVisible = this.menuService.openedMenu;

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.dictionaryService.getDictionary().subscribe();
      effect(() => {
        if (this.authService.authTokenData().token) {
          this.getUserData();
        }
      });
    }
  }

  public closeSidebar(): void {
    this.menuService.toggleMenu();
  }

  public getUserData(): void {
    this.authService.getUserData().subscribe({
      next: userData => {
        if (!userData.phone) {
          this.router.navigate(['/', RoutesEnum.MyAccount, RoutesEnum.ProfileComplete]);
        }
      },
    });
  }
}
